export default __webpack_public_path__ + "static/media/002-snake.87fa7c1d.svg";